var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 2.24931C22.1447 2.63077 21.2333 2.88362 20.2831 3.00638C21.2606 2.413 22.0067 1.48054 22.3574 0.356615C21.4461 0.909077 20.4398 1.29931 19.3674 1.51708C18.5021 0.580231 17.2687 0 15.9232 0C13.3127 0 11.2111 2.15431 11.2111 4.79531C11.2111 5.17531 11.2427 5.54069 11.3203 5.88854C7.40025 5.69415 3.93156 3.78392 1.60137 0.874C1.19456 1.59162 0.955938 2.413 0.955938 3.29723C0.955938 4.95754 1.79688 6.42931 3.05037 7.28138C2.29281 7.26677 1.54962 7.04315 0.92 6.69092C0.92 6.70554 0.92 6.72454 0.92 6.74354C0.92 9.07323 2.55444 11.0083 4.69775 11.4541C4.31394 11.5608 3.89562 11.6119 3.4615 11.6119C3.15963 11.6119 2.85487 11.5944 2.56881 11.5301C3.17975 13.4286 4.91338 14.8244 6.97475 14.8697C5.3705 16.1456 3.33356 16.9144 1.12844 16.9144C0.74175 16.9144 0.370875 16.8968 0 16.8486C2.08869 18.2181 4.56406 19 7.2335 19C15.9102 19 20.654 11.6923 20.654 5.358C20.654 5.14608 20.6468 4.94146 20.6367 4.73831C21.5726 4.06308 22.3589 3.21977 23 2.24931Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.770c4fec194e1e46d63c494c3abf339c.svg";
export { ForwardRef as ReactComponent };